module.exports = __webpack_public_path__ + "front/img/40.6569a41c.png";